import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-error-page',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.scss'],
})
export class ErrorPageComponent implements OnInit {
  ngOnInit(): void {
    setTimeout(() => {
      document.body.style.setProperty('--primary', '#151E46');
      document.body.style.setProperty('--secondary', '#00D6BC');
      document.body.style.setProperty('--tertiary', '#DCDCDC');
      document.body.style.setProperty('--quaternary', '#00D6BC80');
    }, 0);
  }
}
